import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'prototype-viewer',
});

export const viewerRouteRef = createSubRouteRef({
  id: 'prototype-viewer/view',
  parent: rootRouteRef,
  path: '/view/:id',
});
